module.exports = __webpack_public_path__ + "static/img/3.2.3e34271.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/eng/3.2.png
// module id = tpxd
// module chunks = 0